<template>
  <div class="error-valid" v-if="error">
    <div class="error-valid__wrapper">
      <svg width="24" height="24" viewBox="0 0 24 24" stroke="white" xmlns="http://www.w3.org/2000/svg"
           class="error-valid__img">
        <g>
          <path d="M11.8896 4.94507V18.9451" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.88965 11.9451H18.8896" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
      </svg>
      <span class="error-valid__text">{{ error }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ErrorForm',
  data() {
    return {
      error: null
    }
  },
  created() {
    this.$root.$on('error-form-message', (message) => {
      this.error = message;
    })
    this.$root.$on('error-form-clear', () => {
      this.error = null;
    })
  },

}
</script>
